// extracted by mini-css-extract-plugin
module.exports = {"link":"Result_link_WtWv3","listTitle":"Result_listTitle_3IHdt"};